import './style.css';
import './slot2-theme.css';
import { initSlot2Game } from './slot2Game';

const root = document.documentElement;
const d2 = import.meta.env.VITE_S2_D2_BG?.trim();
const beakk = import.meta.env.VITE_S2_BEAKK_BG?.trim();
if (d2) {
  root.style.setProperty('--s2-d2-bg', `url('${d2}')`);
}
if (beakk) {
  root.style.setProperty('--s2-beakk-bg', `url('${beakk}')`);
}

/** file:// 또는 localhost/preview 로 연 경우 minionsView 처럼 항상 게임 표시 (임베드용 게스트는 실제 호스트 배포 빌드에서만) */
function isLocalArtifactOpen(): boolean {
  if (typeof globalThis.location === 'undefined') return false;
  const { protocol, hostname } = globalThis.location;
  if (protocol === 'file:') return true;
  const h = (hostname || '').toLowerCase();
  return h === 'localhost' || h === '127.0.0.1' || h === '[::1]';
}

const explicitGuest =
  import.meta.env.VITE_SLOT2_MEMBER === '0' ||
  import.meta.env.VITE_SLOT2_MEMBER === 'false';

const guestMode = explicitGuest && !isLocalArtifactOpen();

const guestMsg = document.getElementById('s2-guest-msg');
const game = document.getElementById('cr-game-slot2');

if (guestMode) {
  guestMsg?.removeAttribute('hidden');
  game?.setAttribute('hidden', '');
} else {
  guestMsg?.setAttribute('hidden', '');
  game?.removeAttribute('hidden');
  initSlot2Game();
}
